import { ApiError, ApiRedirect } from 'helpers/error';
import axios from 'axios';
import { RequestInterface } from '../search/searchAdapter';
import { CONTENT_API_URL } from '../cms/constants';

// Types for Academy request/response
export type AcademySearchRequest = {
	Topic?: string;
	Type?: string;
	Language: string;
	Take?: number; // default 10
	Skip?: number; // default 0
};

export type AcademySearchResponse = {
	results: Models.AcademyEntry[];
	totalResults: number;
};

export const academyFiltersAdapter = (host: string, locale: string) => {
	if (host === 'localhost' && process.env.FALLBACK_HOSTNAME) {
		host = process.env.FALLBACK_HOSTNAME;
	}

	const url = `${CONTENT_API_URL}Umbraco/api/Academy/Filters?culture=${locale}`;
	const headers = {
		Accept: 'application/json',
		Host: host,
	};

	return axios({
		url,
		method: 'GET',
		headers,
		maxRedirects: 0,
	})
		.then((res) => {
			const { data } = res ?? {};
			if (data) {
				return data;
			}
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			const statusCode = error?.response?.status || 500;

			if (statusCode === 301 || statusCode === 302) {
				throw new ApiRedirect(statusCode, error.response.data.url);
			}

			console.error('Academy Search API error:', error?.response || error);
			throw new ApiError('Search API error', statusCode, message);
		});
};

export const academySearchAdapter = (payload: AcademySearchRequest, host: string, locale: string) => {
	if (host === 'localhost' && process.env.FALLBACK_HOSTNAME) {
		host = process.env.FALLBACK_HOSTNAME;
	}

	const { Topic, Type, Language, Take, Skip } = payload;
	const url = `${CONTENT_API_URL}Umbraco/api/Academy/Search`;
	const headers = {
		Accept: 'application/json',
		Host: host,
	};

	return axios({
		url,
		method: 'GET',
		headers,
		params: { Topic, Type, Language, Take, Skip },
		maxRedirects: 0,
	})
		.then((res) => {
			const { data } = res ?? {};
			if (data) {
				return data;
			}
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			const statusCode = error?.response?.status || 500;

			if (statusCode === 301 || statusCode === 302) {
				throw new ApiRedirect(statusCode, error.response.data.url);
			}

			console.error('Academy Search API error:', error?.response || error);
			throw new ApiError('Search API error', statusCode, message);
		});
};

export const academyEntryDetailAdapter = (id: string, host: string) => {
	if (host === 'localhost' && process.env.FALLBACK_HOSTNAME) {
		host = process.env.FALLBACK_HOSTNAME;
	}

	const url = `${CONTENT_API_URL}Umbraco/api/Academy/Get?id=${id}`;
	const headers = {
		Accept: 'application/json',
		Host: host,
	};

	return axios({
		url,
		method: 'GET',
		headers,
		maxRedirects: 0,
	})
		.then((res) => {
			const { data } = res ?? {};
			if (data) {
				return data;
			}
		})
		.catch((error) => {
			const message = error?.response?.data?.message ?? error;
			const statusCode = error?.response?.status || 500;

			if (statusCode === 301 || statusCode === 302) {
				throw new ApiRedirect(statusCode, error.response.data.url);
			}

			console.error('Academy Search API error:', error?.response || error);
			throw new ApiError('Search API error', statusCode, message);
		});
};
